import classNames from 'classnames'

import Paragraph from 'content-components/_Primatives/Paragraph'
import TextBlock from 'ui-component-library/components/00-Primitives/TextBlock'
import style from './style.scss'

export type Props = {
  authorText: string
  className?: string
  credentialsText?: string
  quoteText: string
}

function Quote(props: Props) {
  const { authorText, className, credentialsText, quoteText } = props

  return (
    <div className={classNames(style.wrapper, className)}>
      <div className={style.inner}>
        <div className={style.quoteContent}>
          <TextBlock className={style.quote}>{quoteText}</TextBlock>
          <Paragraph className={style.byline}>
            <span className={style.author}>{`${authorText}${
              credentialsText ? ', ' : ''
            }`}</span>
            <span>{credentialsText}</span>
          </Paragraph>
        </div>
      </div>
    </div>
  )
}

export default Quote
